import React from 'react';
import { Modal } from 'react-bootstrap';
import { notify } from 'react-notify-toast';

const CouponGeneratedModal = ({ show, couponCode, onClose }) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(couponCode);
      notify.show('Código cupón copiado al portapapeles', 'success');
    } catch (error) {
      notify.show(error, 'error');
    }
  };
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cupón generado</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p className="mb-1">Código de cupón</p>
        <h4>
          {couponCode}{' '}
          <i
            className="fas fa-copy"
            style={{ cursor: 'pointer', marginLeft: 8 }}
            onClick={handleCopy}
          />
        </h4>
      </Modal.Body>
    </Modal>
  );
};

export default CouponGeneratedModal;
